import { render, staticRenderFns } from "./CategoryProductSeries.vue?vue&type=template&id=49c44205&scoped=true"
import script from "./CategoryProductSeries.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryProductSeries.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryProductSeries.vue?vue&type=style&index=0&id=49c44205&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c44205",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLink: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiLink.vue').default})
